"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cuglieri": {
    "69830c90": [{
      "hkey": "89e2c21e",
      "slug": "santa-caterina-di-pittinuri",
      "name": "Santa Caterina di Pittinuri",
      "primary": true,
      "skipSearch": false
    }],
    "santa-caterina": [{
      "hkey": "89e2c21e",
      "slug": "santa-caterina-di-pittinuri",
      "name": "Santa Caterina di Pittinuri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;